import { render, staticRenderFns } from "./HelpShop.vue?vue&type=template&id=776bee3b&scoped=true&"
import script from "./HelpShop.vue?vue&type=script&lang=js&"
export * from "./HelpShop.vue?vue&type=script&lang=js&"
import style0 from "./HelpShop.vue?vue&type=style&index=0&id=776bee3b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776bee3b",
  null
  
)

export default component.exports